import { IRemoteModuleManifest, IServicesDiscovered } from '../types';

class Registry {
  private manifestMap = new Map<string, IRemoteModuleManifest>();

  register(container: string, manifest: IRemoteModuleManifest): void {
    if (this.manifestMap.has(container)) {
      console.warn(`[RM] overwriting  the manifest of ${container}`);
    }
    this.manifestMap.set(container, manifest);
  }
  unregister(container: string): void {
    this.manifestMap.delete(container);
  }

  get(container: string) {
    return this.manifestMap.get(container);
  }

  has(container: string) {
    return this.manifestMap.has(container);
  }

  entries() {
    return this.manifestMap.entries();
  }

  keys() {
    return this.manifestMap.keys();
  }
}

export type IShareScope = Record<
  string,
  {
    loaded?: 1;
    get: () => Promise<unknown>;
    from: string;
    eager: boolean;
  }
>;

export interface IContainerEntry {
  get: (module: string) => Promise<() => any>;
  init: (shareScope: IShareScope, initScope?: Array<unknown>) => Promise<1>;
  initialized?: boolean;
}

export interface IScriptError {
  filename: string;
  lineno: number;
  colno: number;
  timeStamp: number;
  error: { message: string; stack: string };
}

export default class RemoteRuntime {
  // 已知的获取 manifest 的服务
  public readonly servicesDiscovered: IServicesDiscovered = {};
  // 远端模块 manifest 的注册
  public readonly registry: Registry = new Registry();
  // module federation container 的缓存
  public readonly containers: Record<string, IContainerEntry> = {};
  // module federation 的 share scope
  public readonly __SHARE_SCOPE__: Record<string, IShareScope> = {};

  public readonly scriptErrors: Array<IScriptError> = [];
}
